<template>
  <div class="filling-goods-div">
    <div style="padding-top: 5px; font-size: 16px">布匹调整</div>
    <div class="filling-goods-head">
      <div class="filling-goods-head-div">
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">卷号:</div>
          <input style="width: 80%" readonly="readonly" v-model="reeldata" />
        </div>
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">货号:</div>
          <input
            style="width: 80%"
            readonly="readonly"
            class="number"
            v-model="goods_number"
          />
        </div>
        <!-- <div class="head-input-div">
          <div style="width: 20%; text-align: left">行数:</div>
          <input style="width: 80%" readonly="readonly" :value="data.length" />
        </div> -->
      </div>
      <div class="filling-goods-head-div">
        <div class="head-input-div">
          <div style="width: 30%; text-align: left">供应商:</div>
          <input style="width: 70%" readonly="readonly" :value="supplier_xh" />
        </div>
        <div class="head-input-div">
          <div style="width: 30%; text-align: left">现存量:</div>
          <input
            style="width: 70%"
            readonly="readonly"
            name="normsware"
            :value="count"
          />
        </div>
      </div>
    </div>
    <div style="display: flex;  padding:0px 10px 10px 10px;align-items: center;justify-content: center;">
        <div style="width: 20%; text-align: left">卷号描述:</div>
        <input style="width: 80%" readonly="readonly" :value="reelInfo" />
    </div>
   
    <span style="color: red" v-if="hostcs">测试服</span>
    <div
      style="display: flex; justify-content: space-between; align-items: center"
      v-if="outNumber === '未出库'"
    >
      <van-button
        type="info"
        size="small"
        style="display: flex"
        :text="ray"
        @click="holdRay()"
      ></van-button>
      <div>
        <input
          id="reel-input"
          class="get-input"
          @keyup.enter="goGck()"
          ref="getIDInpot"
          v-model="reeldata"
          v-on:blur="hideMessage('reeldata')"
          readonly
          autocomplete="off"
        />
        <!-- <input
          id="gck_number-input"
          class="get-input"
          @keyup.enter="add_mx(gck_number_data)"
          ref="getGCKInpot"
          v-model="gck_number_data"
          v-on:blur="hideMessage('gck_number_data')"
          readonly
          autocomplete="off"
        /> -->
      </div>
    </div>
    <div style="padding: 10%;" v-if="success">
      <div class="info-data">
          <div style="width: 30%; text-align: left">数量调整为:</div>
          <input style="width: 80%" v-model="count_up" type="number"/>
      </div>
      <div class="info-data" >
        <div style="width: 30%; text-align: left">卷号描述:</div>
        <input style="width: 80%"  v-model="reelInfo_up"  />
      </div>
      <div style="padding-top: 20px;" v-if="success">
        <van-button type="info" round class="bottom-button-x" @click="go_save()">保存</van-button>
      </div>
    </div>
    <van-popup v-model="show_print" style="width: 200px;">
      <div style="padding:10px;" class="print-only" id="popupPrint">
        <div>
          <div class="list-data">
            <div class="list-data-div">货号:</div>
            <div class="list-data-div">{{ goods_number }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div">数量:</div>
            <div class="list-data-div">{{ count }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">供应商名称:</div>
            <div class="list-data-div-a">{{ supplier_name }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">缸号:</div>
            <div class="list-data-div-a">{{ cylinder_number }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">门幅:</div>
            <div class="list-data-div-a">{{ menfu }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">备注:</div>
            <div class="list-data-div-a">{{ reelInfo }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">时间:</div>
            <div class="list-data-div-a">{{ nowtime }}</div>
          </div>
        </div>
        <Barcode :JsBarcodeData="JsBarcodeConfigData" />
      </div>
      <van-button type="info" @click="dayin()" style="width: 100px; margin : 10px;">打印</van-button>
    </van-popup>
    <div class="filling-goods-bottom" style="display: flex">
      <van-button type="warning" class="bottom-button" @click="go_index()"
        >回首页</van-button
      >
      <van-button
        v-if="AllowPrint"
        type="info"
        class="bottom-button"
        @click="go_print()"
        >打印标签</van-button
      >
      <!-- <van-button
        v-if="outNumber !== '未出库'"
        type="default"
        class="bottom-button"
        style="background-color: darkgray"
        >确认出库</van-button
      >
      <van-button
        v-if="outNumber !== '未出库'"
        type="info"
        class="bottom-button"
        @click="revocation(id)"
        >撤销出库</van-button
      >
      <van-button
        v-if="outNumber === '未出库'"
        type="default"
        class="bottom-button"
        style="background-color: darkgray"
        >撤销出库</van-button
      >
      <van-button
        type="warning"
        class="bottom-button"
        style="margin: 0"
        @click="more_show = true"
      >
        更多
      </van-button>
      <van-button
        class="bottom-button"
        type="warning"
        style="width: 10%"
        @click="resetClick()"
      >
        +
      </van-button> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import Barcode from '@/components/Barcode';
import html2canvas from 'html2canvas';
import moment from 'moment';
export default {
  name: "FabricAdjustment",
  name: "barcode",
  components: {
    Barcode
  },
  data() {
    return {
      hostcs: false,
      more_show: false,
      ray: "扫描中",
      id: "",
      supplier_xh: "",
      count: "",
      count_up:"",
      data: [],
      style: "",
      allcount: 0,
      reeldata: "",
      goods_number: "",
      reelInfo:"",
      reelInfo_up:"",
      infoType: "1111",
      gck_number_data: "",
      outNumber: "未出库",
      username: "",
      type: "orderInfo",
      count: "",
      success: false,
      show_print: false,
      AllowPrint: false,
      nowtime: '',
      jieliu: false,
      menfu: '',
      cylinder_number: "",
      supplier_name:"",
      JsBarcodeConfigData: {
        text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
        lineColor: "#000000", //二维码颜色
        background: "#fff", //二维码背景色
        //width: this.widthStyleObj, 
        bottomtext: '',
      }
    };
  },
  mounted() {
    this.username = JSON.parse(window.localStorage.getItem("userinfo"));
    // if (this.$route.query.id !== undefined) {
    //   this.getIdData(this.$route.query.id);
    // }
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
    setTimeout(() => {
      // this.countAll();
      if (this.outNumber === "未出库") {
        this.focus();
      }
    }, 500);
    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }
  },
  methods: {
    goGck() {
      // 输入卷号 弹出现存量
      this.get(this.APIOBJ.ClothAdjustment, { reel: this.reeldata }).then(
        (res) => {
          if (res.data.status == 1) {
            // 如果是1  就说明成功
            this.count = res.data.data.store;
            this.count_up = res.data.data.store;
            this.supplier_xh=res.data.data.supplier_xh;
            this.supplier_name=res.data.data.supplier;
            this.cylinder_number=res.data.data.cylinder_number;
            this.menfu=res.data.data.menfu;
            this.reelInfo=res.data.data.reel_detail;
            this.reelInfo_up=res.data.data.reel_detail;
            this.goods_number=res.data.data.number;
            this.success=true;
            this.AllowPrint=true;
          } else if(res.data.status == 0){
            Toast(res.data.msg);
          }else{
            Toast('失败');
          }
        }
      );
      this.gck_input();
    },
    go_save(){
      if(this.count_up!=""&&this.count_up>=0){
        var reduce=this.count-this.count_up;
        //let store=parseFloat(this.count_up);
        this.post(this.APIOBJ.ClothAdjustment, { reel: this.reeldata ,comment: this.reelInfo_up,reduce:reduce}).then(
          (res) => {
            if (res.data.status == 1) {
              this.reelInfo=this.reelInfo_up;
              this.count=this.count_up;
              Toast('更新保存成功');
            } else{
              Toast('更新失败');
            }
          }
        )        
      }
      else{
        Toast('数量调整不能为空或负!');
      }
    },
    go_print() {
        // this.get("/IncreaseStore", {
        //   number: this.goods_number,
        //   reel_detail: this.reelInfo,
        //   cylinder_number: this.cylinder_number,
        //   store: this.count,
        //   supplier_name: this.supplier_name,
        //   supplier_xh: this.supplier_xh,
        //   menfu: this.menfu,
        // }).then((res) => {
        //   console.log(res.data);
        //   if (res.data.status == 1) {
            this.nowtime = moment().format('YYYY-MM-DD HH:mm:ss');
            this.JsBarcodeConfigData.text = this.reeldata;
            this.JsBarcodeConfigData.bottomtext = this.reeldata;
            this.show_print = true;
            this.jieliu = false;
        //   } else if (res.data.status == 0) {
        //     this.jieliu = false;
        //     Toast(res.data.msg)
        //   } else {
        //     this.jieliu = false;
        //     Toast("失败");
        //   }
        // })

    },
    dayin() {
      html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
        //document.body.appendChild(canvas);
        var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
        var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
        this.reelInfo = '';
        this.count = '';
        this.supplier_xh = '';
        this.callAndroid(imageBase64);
      });
    },
    callAndroid(imageBase64) {
      var BASE64_ENCODED_IMAGE_DATA = imageBase64;
      var imageData = BASE64_ENCODED_IMAGE_DATA;
      console.log(imageData);
      this.show_print = false;
      Android.receiveImage(imageData);
      alert("printPreview");
    },
    gck_input() {
      // this.$refs.getGCKInpot.focus();
      // this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
      // setTimeout(() => {
      //   this.$refs.getGCKInpot.removeAttribute("readonly");
      // }, 200);
    },

    hideMessage(title) {
      if (title === "reeldata") {
        if (this.reeldata === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
      if (title === "gck_number_data") {
        if (this.gck_number_data === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
    },
    holdRay() {
      this.ray = "扫描中";
      if (this.reeldata === "") {
        this.focus();
      } else if (this.gck_number_data === "") {
        this.gck_input();
      }
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },
    // gourl(url) {
    //   url = "http://www.lcyjfz.com/home/scan?url=" + url;
    //   window.location.href = url;
    // },
    go_index() {
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },
  },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";
.info-data {
  display: flex;  
  padding:0px 10px 10px 10px;
  align-items: center;
  justify-content: center;
  }
.bottom-button-x{
  border-radius: 0.5em;
  width: 35%;
}
.list-data {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.list-data-div {
  padding-right: 3px;
  text-align: left;
  font-size: 18px;
}

.list-data-div-a {
  padding-right: 3px;
  text-align: left;
  font-size: 14px;
}
</style>